import React, { useState } from 'react';
import {
  Collapse,
  Container,
  Nav,
  Navbar,
  NavbarBrand,
  NavItem,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import translations from 'services/translations/translations';
import Sidebar from './Sidebar';
import InlookLogo from '../../../assets/InlookLogoWhite.png';
import '../../../style/layout/navbar/NavMenu.css';

const NavMenu = (): JSX.Element | null => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { t } = useTranslation(translations.common);

  const configuration = useSelector((state: any) => state.configuration);

  const getProjectAndConfiguration = () => {
    if (configuration === null) {
      return null;
    }

    if (configuration.name !== null) {
      return (
        <NavItem>
          <div className="nav-title">
            <h2>
              <Link to={`/projects/${configuration.project.id}`}>
                {configuration.project.name}
              </Link>
            </h2>
            <h2>{configuration.name}</h2>
          </div>
        </NavItem>
      );
    }

    return (
      <NavItem>
        <div className="nav-title">
          <h2>
            <Link to={`/projects/${configuration.project.id}`}>
              {configuration.project.name}
            </Link>
          </h2>
          <h2>{t(`${translations.common}:New configuration`)}</h2>
        </div>
      </NavItem>
    );
  };

  return (
    <header>
      {sidebarOpen === true ? (
        <Sidebar isOpen={sidebarOpen} closeFunction={setSidebarOpen} />
      ) : null}
      <div className="space-reserver" />
      <Navbar
        className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3 navbar-color navbar-size fixed-top"
        light
      >
        <Container className="full-container">
          <Nav
            className="navmenu-hamburger-button"
            onClick={() => {
              setSidebarOpen(true);
            }}
          >
            <p className="navmenu-hamburger-text">☰</p>
          </Nav>
          <NavbarBrand className="navbar-logo" tag={Link} to="/">
            <img alt="Inlook" src={InlookLogo} />
            <h2 className="glass-configurator-title">
              {t(`${translations.common}:Glass Configurator`)}
            </h2>
          </NavbarBrand>
          <Collapse className="collapse-section" isOpen navbar>
            <Nav>{getProjectAndConfiguration()}</Nav>
          </Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default NavMenu;
